module.exports = __webpack_public_path__ + "./img/formerclient.9460ad1a12549eab213d1226b6186fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/formerclient.png
// module id = ./src/containers/Briefcase/entry/icons/formerclient.png
// module chunks = 0